import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { ConfirmationElementSettings } from '../confirmation-control/confirmation-control-model';

@Component({
    selector: 'topo-slack-template-confirmation-element',
    templateUrl: './slack-confirmation-control.component.html',
    styleUrls: ['./slack-confirmation-control.component.scss'],
    standalone: false
})
export class SlackTemplateDesignConfirmationElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this.confirmationText = !!this.messageSettings?.confirmationText
      ? this.templateDesignerService.getTranslateText(this.messageSettings?.confirmationText, value)
      : null;
    this.confirmationButtons = [];
    this.messageSettings?.confirmationButtons?.forEach(b => {
      this.confirmationButtons.push({
        uId: b.uId,
        number: b.number,
        type: b.type,
        text: this.templateDesignerService.getTranslateText(b.text, value)
      });
    });
  }

  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;

  ConfirmationType = ConfirmationType;
  confirmationText: string;
  yesConfirmationText: string;
  noConfirmationText: string;
  confirmationButtons: { uId: string; number: number; type: ConfirmationType; text: string }[];
  displayAsLink: boolean;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    const settings = this.control?.settings as ConfirmationElementSettings;
    this.displayAsLink = settings?.displayAsLink === true;
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;
    const settings = this.control?.settings as ConfirmationElementSettings;
    this.displayAsLink = settings?.displayAsLink === true;
  }
  edit(): void {}

  setRuntimeData(data: any): void {}

  setDisplayAsLink(): void {
    this.displayAsLink = !this.displayAsLink;
    const settings = {
      displayAsLink: this.displayAsLink
    } as ConfirmationElementSettings;

    this.settingsChanged.emit({ uId: this.control.uId, settings: settings });
  }
}
